import {Injectable} from "@angular/core";
import {SistemaAutenticacionComponent} from "../../components/sistema-autenticacion/sistema-autenticacion.component";
import {NgbModal, NgbModalConfig, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import * as pubsub from "pubsub-js"
import {PubsubKeyEnum} from "../../enums/pubsub-key.enum";

@Injectable({providedIn: 'root'})
export class SystemAuthenticationService {
  private modalRef!: NgbModalRef;
  errorToken: boolean = false;
  errorType: string = '';
  loading = false;

  constructor(
    private modalService: NgbModal,
    private modalConfig: NgbModalConfig
  ) { }

  /**
   *  
   * @function openValidationToken
   * @description
   * is not mandatory to pass these events name, but if you have multiple auth modals in a same component
   * it is convenient to give a diferent name to each one
   * @param {?string} [customEventName] event executed after validate token
   * @param {?string} [customCloseEventName] event executed when close the modal
   */
  openValidationToken(customEventName?: string, customCloseEventName?: string) {
    this.modalRef = this.modalService.open(SistemaAutenticacionComponent, {modalDialogClass: 'system-auth-modal-dialog'});
    this.modalRef.componentInstance.modalRef = this.modalRef;
    this.modalRef.componentInstance.customEventName = customEventName;
    this.modalRef.componentInstance.customCloseEventName = customCloseEventName;
  }

  getRef() {
    return this.modalRef;
  }

  setError(errorType: string) {
    pubsub.publish(PubsubKeyEnum.systemAuthenticationErrorEvent,{errorType})
  }

  showLoading(){
    this.loading = true;
  }

  showErrorMessage() {
    this.modalRef.componentInstance.showErrorMessage = true
  }

  hideLoading(){
    this.loading = false;
  }

}
